import React, { useState, useEffect } from 'react';
import { X, Download, Smartphone } from 'lucide-react';
import { initInstallPrompt, showInstallPrompt, canShowInstallPrompt, isAppInstalled } from '../pwa';

const InstallBanner = () => {
  // Banner komplett deaktiviert auf Kundenwunsch
  return null;
  
  /*
  const [showBanner, setShowBanner] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Check if already installed
    if (isAppInstalled()) {
      setIsInstalled(true);
      return;
    }

    // Check if user dismissed the banner before
    const dismissed = localStorage.getItem('jannesmann_install_dismissed');
    const dismissedTime = dismissed ? parseInt(dismissed) : 0;
    const daysSinceDismissed = (Date.now() - dismissedTime) / (1000 * 60 * 60 * 24);

    // Show again after 7 days
    if (daysSinceDismissed < 7) {
      return;
    }

    // Listen for install prompt
    initInstallPrompt((available) => {
      setShowBanner(available);
    });

    // Small delay to check if prompt is available
    setTimeout(() => {
      if (canShowInstallPrompt()) {
        setShowBanner(true);
      }
    }, 3000);
  }, []);

  const handleInstall = async () => {
    const installed = await showInstallPrompt();
    if (installed) {
      setShowBanner(false);
      setIsInstalled(true);
    }
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('jannesmann_install_dismissed', Date.now().toString());
  };

  if (isInstalled || !showBanner) {
    return null;
  }

  return (
    <div className="fixed bottom-20 left-4 right-4 md:left-auto md:right-20 md:w-80 z-40 animate-slide-up">
      <div className="bg-white rounded-xl shadow-xl border border-gray-200 p-4">
        <button
          onClick={handleDismiss}
          className="absolute top-2 right-2 p-1 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Schließen"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="flex items-start gap-3">
          <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center flex-shrink-0">
            <Smartphone className="w-6 h-6 text-red-600" />
          </div>
          
          <div className="flex-1 pr-4">
            <h3 className="font-semibold text-gray-900 text-sm">App installieren</h3>
            <p className="text-xs text-gray-500 mt-0.5">
              Installieren Sie unsere App für schnellen Zugriff auf Baumaschinen & Zubehör
            </p>
          </div>
        </div>

        <div className="flex gap-2 mt-3">
          <button
            onClick={handleDismiss}
            className="flex-1 px-3 py-2 text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
          >
            Später
          </button>
          <button
            onClick={handleInstall}
            className="flex-1 px-3 py-2 text-sm bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors flex items-center justify-center gap-1"
          >
            <Download className="w-4 h-4" />
            Installieren
          </button>
        </div>
      </div>

      <style>{`
        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-slide-up {
          animation: slide-up 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default InstallBanner;
*/
}

export default InstallBanner;
